import get from 'lodash/get';
import {
  SETUP_INITIAL_DATA_REQUEST,
  SETUP_INITIAL_DATA_SUCCESS,
  SETUP_INITIAL_DATA_FAILURE
} from 'base/actions/actionTypes';

const setupDataFactory = (entity, processPayload = payload => payload) => (
  state = {},
  action
) => {
  switch (action.type) {
    case `${SETUP_INITIAL_DATA_REQUEST}`: {
      return {
        ...state,
        isFetching: true,
        error: []
      };
    }
    case `${SETUP_INITIAL_DATA_SUCCESS}`: {
      return {
        ...state,
        ...processPayload(action.payload[entity]),
        isFetching: false,
        error: []
      };
    }
    case `${SETUP_INITIAL_DATA_FAILURE}`: {
      return {
        ...state,
        isFetching: false,
        error: [get(action, 'payload.message')]
      };
    }
    default:
      return state;
  }
};

export default setupDataFactory;
